import React from "react";
import "./AdditionalResult.css";

function AdditionalResult({ image, title, description, value, divider }) {
  console.log("image: "+image)
  return (
    <div className="additional-result">
      <div className="ar-text-container">
        <img className="ar-image" alt="" src={image} />
        <div className="ar-text">
          <p className="ar-title">{title}</p>
          <div className="ar-description">
            {description ? <p className="ar-description-text">{description}</p> : null}
            <p className="ar-description-value">{value}</p>
          </div>
        </div>
      </div>
      {divider && <div className="divider" />}
    </div>
  );
}

export default AdditionalResult;
